<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-66">
      <user-edit-form ref="edit_profile" header-color="green"> </user-edit-form>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-33">
      <user-permission-form ref="permission_profile" header-color="green">
      </user-permission-form>
    </div>
  </div>
</template>
<script>
import UserEditForm from "./UserStaffUpdateComponent/UserEditForm";
import UserPermissionForm from "./UserStaffUpdateComponent/UserPermissionForm";

export default {
  data() {
    return {
      wizardModel: {},
      userID: null,
      // User profile
      first_name: null,
      last_name: null,
      title: null,
      gender: null,
      mobile_phone: null,
      country: null,
      picture: null,
      role: null,
      is_active: false
    };
  },
  components: {
    UserEditForm,
    UserPermissionForm
  },
  methods: {},
  mounted() {
    if (this.$route.meta.staff === "admin") {
      this.role = 1;
    } else if (this.$route.meta.staff === "agency") {
      this.role = 3;
    } else if (this.$route.meta.staff === "university") {
      this.role = 4;
    } else if (this.$route.meta.staff === "dorm") {
      this.role = 5;
    }

    this.$refs["edit_profile"].role = this.role;

    this.userID = this.$route.params.id;
    this.$store.getUser(this.role, this.userID).then(response => {
      // first step
      this.$refs["edit_profile"].userID = response.data.id;
      this.$refs["edit_profile"].first_name = response.data.first_name;
      this.$refs["edit_profile"].last_name = response.data.last_name;
      this.$refs["edit_profile"].picture = response.data.picture;
      //second step
      this.$refs["edit_profile"].title = response.data.title;
      if (response.data.gender === "Male") {
        this.$refs["edit_profile"].gender = "M";
      } else {
        this.$refs["edit_profile"].gender = "F";
      }
      this.$refs["edit_profile"].mobile_phone = response.data.mobile_phone;
      this.$refs["edit_profile"].country = response.data.country.id;
      this.$refs["edit_profile"].is_active = response.data.is_active;
    });
  }
};
</script>
